export const ITEMS_SET = "ITEMS::SET"
export const ITEMS_CLEAR = "ITEMS::CLEAR"
export const ITEMS_ITEM_UPDATE = "ITEMS::ITEM::UPDATE"
export const ITEMS_MOVE = "ITEMS::MOVE"



// WEBPACK FOOTER //
// ./src/types/actions/items.js